import { useTranslation } from 'react-i18next';
import { focusRing } from '@attendance/ui/focus';

/**
 * Skip-link: visible to keyboard/screen-reader users only on focus. Targets
 * the `<main id="main">` in `AppShell` so AT users can bypass the sidebar and
 * header on every page. WCAG 2.1 §2.4.1.
 *
 * Focus was the last `ring-*` holdout in the app: `focus:ring-2
 * focus:ring-ring` painted its 2px gap in an OPAQUE `--background`, which is
 * wrong the moment this chip is over anything but the page. It takes the canon
 * (see packages/ui/src/lib/focus.ts), whose `outline-offset` gap is
 * transparent.
 */
export function SkipToContent(): JSX.Element {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      className={`sr-only focus:not-sr-only focus:absolute focus:start-2 focus:top-2 focus:z-[100] focus:rounded-control focus:bg-primary focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:shadow-lg ${focusRing}`}
    >
      {t('appShell.skipToContent', 'Skip to main content')}
    </a>
  );
}
